import { field, date, relation,text } from '@nozbe/watermelondb/decorators';
import { Model } from '@nozbe/watermelondb';
import { DISPUTES_SCHEMA } from '../schema';

export default class Disputes extends Model {
    static table = DISPUTES_SCHEMA;

    static associations = {
        wallet_txns: { type: 'belongs_to', key: 'wallet_txns_id' },
        business: { type: 'belongs_to', key: 'business_id' },
    }

    @text('customer_number') customer_number;
    @text('telco_network') telco_network;
    @field('amount') amount;
    @text('status') status;

    @date('created_at') created_at;

    @relation('wallet_txns', 'wallet_txns_id') wallet_txns;
    @relation('business', 'business_id') business;
}